(ns frontend.ui.component.lp-portal.report.body.feeder.endowment.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))


(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  {:fund-name          (:fund-name report-data)
   :reference-date     (:reference-date report-data)
   :basic-information-primary (report-ctl/with-footnote
                               props
                               :basic-information-primary-footnotes
                               (get-in report-data
                                       [:basic-information-primary]))
   :basic-information-secondary (report-ctl/with-footnote
                                 props
                                 :basic-information-secondary-footnotes
                                 (get-in report-data
                                         [:basic-information-secondary]))
   :yleista-rahastosta (report-ctl/rich-content props
                                                :yleista-rahastosta-text)
   :rahaston-tilanne-yhteenveto (report-ctl/with-footnote
                                 props
                                 :rahaston-tilanne-yhteenveto-footnotes
                                 (get-in report-data [:rahaston-tilanne-yhteenveto]))
   :yhteenveto         (report-ctl/with-footnote
                        props
                        :yhteenveto-footnotes
                        (get-in report-data [:yhteenveto]))})